const mode = 'PROD';

export const API_BASE_URL =
    mode === 'DEV'
        ? 'http://localhost/alefolia/src/php'
        : 'https://admin.alefolia.com/backend/php';

export const maskCnpjCpf = (value) => {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 11) {
        return digits
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return digits
        .slice(0, 14)
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
};

let cachedIpv4 = null;

/**
 * Obtém o IPv4 público do cliente através de API externa para garantir IPv4 (e evitar IPv6).
 */
export const getPublicIpv4 = async () => {
    if (cachedIpv4) return cachedIpv4;

    // 1. Tenta api4.ipify.org (força e retorna exclusivamente IPv4)
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3500);
        const res = await fetch('https://api4.ipify.org?format=json', { signal: controller.signal });
        clearTimeout(timeoutId);
        const data = await res.json();
        if (data && data.ip && data.ip.includes('.')) {
            cachedIpv4 = data.ip.trim();
            return cachedIpv4;
        }
    } catch (e) {
        // Fallback para próximo serviço
    }

    // 2. Fallback: icanhazip (específico para IPv4)
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3500);
        const res = await fetch('https://ipv4.icanhazip.com', { signal: controller.signal });
        clearTimeout(timeoutId);
        const text = await res.text();
        const ip = (text || '').trim();
        if (ip && ip.includes('.')) {
            cachedIpv4 = ip;
            return cachedIpv4;
        }
    } catch (e) {
        // Fallback para próximo serviço
    }

    // 3. Fallback: api.ipify.org
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3500);
        const res = await fetch('https://api.ipify.org?format=json', { signal: controller.signal });
        clearTimeout(timeoutId);
        const data = await res.json();
        if (data && data.ip && data.ip.includes('.')) {
            cachedIpv4 = data.ip.trim();
            return cachedIpv4;
        }
    } catch (e) {
        // Silencioso
    }

    return '';
};
